/**
 * Created by macuser on 6/22/17.
 *
 * Some enumerations
 */
export default {
  UserStatus: {
    Normal: "normal",
    Locked: "locked",
    Deleted: "deleted",
    PendingApproval: "pending",
  },
  AppStatus: {
    Normal: "normal",
    Deleted: "deleted",
    PendingApproval: "pending",
  },
  OrgStatus: {
    Pending: "pending",
    Deleted: "deleted",
    Locked: "locked",
    Normal: "normal",
  },
  FileVisibility: {
    Private: "private",
    Public: "public",
    Object: "object",
  },
  DocStatus: {
    Normal: "normal",
    Deleted: "deleted",
  },
  FormQuestionType: {
    Text: "text",
    ExtendedText: "extended-text",
    Date: "date",
    Boolean: "boolean",
    Select: "select",
    Radio: "radio",
    Numeric: "numeric",
    CurrentLocation: "current-location",
    CurrentDate: "current-date",
    Instructions: "instructions",
    FilePath: "file-path",
  },
};



//////////////////
// WEBPACK FOOTER
// ./public/js/app/enums.js
// module id = 168
// module chunks = 1